import { forwardRef } from 'react';

import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { useAuth } from '@hooks';
import { selectUserFirstName } from '@hooks/useAuth/selectors';

import * as S from './styles';

export type PostFields = {
  message: string;
};

const Editor = forwardRef<HTMLTextAreaElement>((_, forwardedRef) => {
  const user = useAuth(selectUserFirstName);
  const { register } = useFormContext<PostFields>();
  const { t } = useTranslation();

  const { ref, ...rest } = register('message', {
    required: true,
  });

  const handleRef = (node: HTMLTextAreaElement | null) => {
    if (node) {
      ref(node);

      if (typeof forwardedRef === 'function') {
        forwardedRef(node);
      } else if (forwardedRef) {
        // eslint-disable-next-line no-param-reassign
        forwardedRef.current = node;
      }
    }
  };

  return (
    <S.Container>
      <S.AutosizeTextarea
        minRows={3}
        maxLength={1000}
        placeholder={t('pages.newsfeed.shared', { user })}
        {...rest}
        ref={handleRef}
      />
    </S.Container>
  );
});

Editor.displayName = 'Editor';

export default Editor;
